module.exports = __webpack_public_path__ + "html/subscription-price-block_d930eeb8cc868aec2efbcce26babaecd.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription-price-block.html
// module id = o701
// module chunks = 3